<template>
  <el-card style="height: 400px; overflow-y: auto" class="default-info-card">
    <div slot="header">
      <h2 style="margin: 0px">{{ info.OrgInfo.OrganismName }}</h2>
      <h4 style="margin: 5px; color: #999999;">{{ info.OrgInfo.Kingdom }} > {{ info.OrgInfo.Group }} > {{ info.OrgInfo.SubGroup }} > {{ info.OrgInfo.OrganismName }}</h4>
    </div>
    <div class="default-info-card-body">
      <div class="side-header">
        {{ "Genome Info" | allCaps }}
      </div>
      <el-row>
        <el-col :span="8">
          <span class="genome-info-label">Genome Size:</span> {{ info.GenomeInfo.GenomeSize | exponentiateBases }}
        </el-col>
        <el-col :span="8">
          <span class="genome-info-label">GC%:</span> {{ info.GenomeInfo.GC }}
        </el-col>
        <el-col :span="8">
          <span class="genome-info-label"># Sequences:</span> {{ info.GenomeInfo.NumSeqs }}
        </el-col>
      </el-row>
      <el-row style="margin-top: 5px;">
        <el-col :span="8">
          <span class="genome-info-label">Gene Annotation: </span> {{ info.OrgInfo.Annotation === 'Y' ? 'Yes' : 'No' }}
        </el-col>
        <el-col :span="8">
          <span class="genome-info-label">Source:</span> {{ info.OrgInfo.Source }}
        </el-col>
        <el-col :span="8">
          <span class="genome-info-label">Taxonomy ID:</span> {{ info.OrgInfo.TaxID }}
        </el-col>
      </el-row>
      <br>
      <div class="side-header">
        {{ "Repeat Info" | allCaps }}
      </div>
      <el-row>
        <el-col :span="8">
          <div class="repeat-info-value">{{ info.RepInfo.TotalRepFreq }}</div>
          <div class="repeat-info-label"># Microsatellites</div>
        </el-col>
        <el-col :span="8">
          <div class="repeat-info-value">{{ info.RepInfo.TotalRepBases | exponentiateBases }}</div>
          <div class="repeat-info-label">Genome Covered</div>
        </el-col>
        <el-col :span="8">
          <div class="repeat-info-value">{{ info.RepInfo.PercentGenomeCovered }}</div>
          <div class="repeat-info-label">Genome Covered</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="repeat-info-value">{{ info.RepInfo.NumRepClasses }}/501</div>
          <div class="repeat-info-label"># Repeat Classes</div>
        </el-col>
        <el-col :span="8">
          <div class="repeat-info-value">{{ parseInt(info.RepInfo.RepDensityByFreq) }}</div>
          <div class="repeat-info-label">SSRs per Mb Genome</div>
        </el-col>
        <el-col :span="8">
          <div class="repeat-info-value">{{ info.RepInfo.RepDensityByBases | exponentiateBases }}</div>
          <div class="repeat-info-label">per Mb Genome</div>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'SpeciesInfoCard',
  props: {
    info: Object
  },
  filters: {
    allCaps (string) {
      if (!string) {
        return
      }
      return string.toUpperCase()
    },
    exponentiateBases (num) {
      if (!num) {
        return
      }
      let base = parseInt(num)
      if (base < 1000) {
        return `${base}bp`
      } else if (base < 1000000) {
        return `${(base/1000).toFixed(2)} Kb`
      } else if (base < 1000000000) {
        return `${(base/1000000).toFixed(2)} Mb`
      } else {
        return `${(base/1000000000).toFixed(2)} Gb`
      }
    }
  }
}
</script>

<style scoped>
div {
  font-family: 'Lato', Arial, Helvetica, sans-serif;
}

div.side-header {
  font-weight: bold;
  text-align: left;
  margin-top: 10px;
}

div.el-row {
  text-align: left;
  margin-left: 5%;
  margin-top: 10px;
}

div.repeat-info-value {
  font-size: 2em;
  font-family: 'Unica One', Arial, Helvetica, sans-serif;
  /* font-weight: bold; */
}

div.repeat-info-label {
  font-family: 'Oxygen', Arial, Helvetica, sans-serif;
}
</style>

